function zoom() {
	let zoom = 0;
	if ($(window).width() > 1023) {
		zoom = $(window).width() / 1920;
		$('.zoom').css("zoom", zoom);
		$('.zoom').css("-moz-transform", "scale(" + zoom + ")");
		$('.zoom').css("-moz-transform-origin", "0 0");
	} else {
		zoom = 1;
		$('.zoom').css("zoom", zoom);
		$('.zoom').css("-moz-transform", "none");
		$('.zoom').css("-moz-transform-origin", "0 0");
	}
	return zoom;
}

$(document).ready(function() {
	zoom();
	let zoomValue = zoom();
	$(window).on('resize', function() {
		zoom();
		zoomValue = zoom();
	});

	$(document).on('click', '.js-anchor-pre-order', function (event) {
		console.log(zoomValue);
	    event.preventDefault();
		$('html, body').animate({
	        scrollTop: $('#' + $(this).attr('data-anchor')).offset().top * zoomValue + $(window).scrollTop() * (1 - zoomValue)
	    }, 500);
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/main/zoom.js